import React, { useState } from 'react';
import { object } from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './TableRowMenu.module.css';

const MapObjectToSensorTableRowMenu = ({
    clearSensor,
    object,
    onConfigureSensorModal,
    setObject,
    ...props
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleOpen(event) {
        setObject(object);
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleNewSensor() {
        onConfigureSensorModal(true);

        handleClose();
    }

    function handleClearSensor() {
        clearSensor(object);

        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-owns={open ? 'render-props-menu' : undefined}
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                <MenuItem onClick={handleNewSensor}>
                    <img
                        alt="sensor icon"
                        className={classes.contextIcon}
                        src="/assets/images/sensorTreeIcon.svg"
                    />
                    Configure Sensor
                </MenuItem>
                <MenuItem onClick={handleClearSensor}>
                    <img
                        alt="sensor icon"
                        className={classes.contextIcon}
                        src="/assets/images/resetIconFlat.svg"
                    />
                    Clear Sensor
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
};

MapObjectToSensorTableRowMenu.defaultProps = {
    object: {}
};

MapObjectToSensorTableRowMenu.propTypes = {
    object: object
};

export default MapObjectToSensorTableRowMenu;
